<section id="secao-descricao" class="mt-5 w-100">
  <div class="container w-100 h-100">
    <div class="title">
      <h1 class="font-weight-bold">Cultura Colaborativa Educere</h1>
    </div>
    <div class="paragrafo-explicativo h-25 font-weight-normal">
      <p>
        Com o apoio das empresas mantenedoras e parceiras, a Fundação Educere
        conta com equipe qualificada de professores e empresários voluntários
        que colaboram com a formação dos alunos do Projeto Educere.
      </p>
    </div>

    <!-- <div
      class="div-img w-25 float-right position-relative overflow-hidden rounded-circle"
    >
      <img
        class="imagem-descricao w-100 h-100"
        src="../../../../assets/imagens/imagem-descricao-cultura-colaborativa.png"
      />
    </div> -->
  </div>
</section>
